import type { EnemyConfig } from '../../entities/EnemyConfig';

export const MOUSE_CONFIG: EnemyConfig = {
  id: 'mouse',
  displayName: 'Мышь',
  maxHp: 1,
  speed: 80,
  movementBehavior: 'chase',
  size: 14,
  color: 0x6b4423,
  scoreReward: 3,
};
